import { render, staticRenderFns } from "./HoloverzInfoRow.vue?vue&type=template&id=c79fb57c&scoped=true"
import script from "./HoloverzInfoRow.vue?vue&type=script&lang=js"
export * from "./HoloverzInfoRow.vue?vue&type=script&lang=js"
import style0 from "./HoloverzInfoRow.vue?vue&type=style&index=0&id=c79fb57c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79fb57c",
  null
  
)

export default component.exports